import Actions from '../Collection/actions'

const actions = Actions.get('EDITION_');

export default actions;
